import { memo } from 'react';
import cn from 'classnames';
import { Button, Element, Icon, Title } from 'src/components';
import Card from 'src/components/card';

const MAP_STATE = {
    fail: {
        title: 'KHÔNG THỂ THỰC HIỆN',
        content: 'Đã có lỗi xảy ra, bạn vui lòng thực hiện lại',
    },
    success: {
        title: 'ĐÃ GỬI THÔNG TIN',
        content:
            'Cám ơn bạn đóng góp ý kiến. Chúng tôi sẽ kiểm tra lại nội dung trong thời gian sớm nhất.',
    },
};

export default memo(function ModalSuccess({ hide, reportState }: any) {
    const responseStatus = reportState.value ? 'success' : 'fail';
    const { title, content } = MAP_STATE[responseStatus];

    return (
        <Card>
            <Card.Header
                className={cn(
                    'relative',
                    'px-[25px] py-[15px]',
                    'text-center',
                    'border border-solid border-[#e9ecef]'
                )}
            >
                <Title className={'text-[2.4rem] leading-[30px] uppercase'}>
                    {title}
                </Title>
                <Element className={'text-[1.6rem] leading-[22px]'}>
                    {content}
                </Element>
                <Element renderAs="a" onClick={hide}>
                    <Icon
                        className={cn(
                            'absolute top-[15px] right-[15px]',
                            'text-black text-[1.5rem]',
                            'opacity-50',
                            'hover:opacity-100'
                        )}
                        icon="close"
                    />
                </Element>
            </Card.Header>
            <Card.Footer
                className={cn(
                    'flex-nowrap justify-center',
                    'px-[25px] py-[20px]',
                    'h-auto',
                    'rounded-none',
                    'text-center',
                )}
            >
                <Button
                    className={cn(
                        'rounded-[3px]',
                        'w-[240px] h-auto',
                        'text-[1.8rem] leading-[1.5] font-bold uppercase',
                        'mx-[5px] px-[1rem] py-[0.5rem]',
                        'border border-solid border-[#e9ecef]'
                    )}
                    title="Đóng"
                    color={'primary'}
                    onClick={hide}
                >
                    Đóng
                </Button>
            </Card.Footer>
        </Card>
    );
});
